import { Fragment, useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FieldArray, Formik } from "formik";
import { useTranslation } from 'react-i18next';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import _ from 'lodash';
import { ToastService } from "../../../services/toast.service";
import { HeaderRegister } from "../../../components/HeaderRegister";
import BranchService from "../../../services/branch.service";
import storageService from "../../../services/storage.service";

export interface configImpositionModelCit {
  id: number;
  fullName: string;
  checked: boolean;
  isIntegrationSiga: boolean;
}

const SigaSatelliteList = () => {
  const [initialValues, setInitialValues] = useState({
    selectionTypeId: "3", // Definindo o valor padrão como "3"
    listValues: []
  });

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const [selectedList, setSelectedList] = useState([]);

  const initialize = async () => {
    setLoading(true);

    // Carregar os dados do tipo de configuração 
    BranchService.getAll().then((response: any) => {
      const listValues = response.result.datasets[0].data;
      setInitialValues(prevValues => ({
        ...prevValues,
        listValues: listValues
      }));

      // Inicializar selectedList com base em isIntegrationSiga
      //console.log("listaValues: " + JSON.stringify(listValues));
      const selectedIds = listValues
        .filter((item: configImpositionModelCit) => item.isIntegrationSiga)
        .map((item: configImpositionModelCit) => item.id);
      
      setSelectedList(selectedIds);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
      console.error("Error loading data:", error);
    });
  };

  useEffect(() => {
    initialize();
  }, []);

  const returnSubTitle = (label: string) => {
    if (label == '1') return t('CONFIG.GROUP_GENERAL');
    if (label == '2') return t('CONFIG.GROUP_PROFILE');
    if (label == '3') return t('CONFIG.PARAMETER_CIT_SUBTTITLE');
    if (label == '4') return t('CONFIG.GROUP_BRANCH_ACTION');
    if (label == '5') return t('CONFIG.GROUP_BRANCH_ACTION_CASH_CHANGE_DELIVERY')
    return '';
  }

  const toggleCheckbox = (id: number) => {
    const updatedList = selectedList.includes(id)
      ? selectedList.filter(item => item !== id)
      : [...selectedList, id];
  
    setSelectedList(updatedList);
  };
  

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  };

  const user = storageService.getUser();
  
  const onSubmit = async (date) => {
    try {
      if (date.selectionTypeId == undefined || date.selectionTypeId == '') {
        ToastService.warn(t('CONFIG.ALERT_TYPE_NEEDED'), null);
        return;
      }
  
      const selectedValues = initialValues.listValues.map(item => ({
        branch_id: item.id,
        isIntegrationSiga: selectedList.includes(item.id)
      }));
  
      let dataset = {
        dataset: 'branch',
        data: 
          selectedValues,
      };
  
      let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };
  
      date.Id = date.selectionTypeId;
      date= selectedValues;
      //console.log("Values do request: ", requestParams)
      const response: any = await BranchService.InsBranchIntegrationSiga(requestParams);
      if (response.success) {
        ToastService.success(t('CONFIG.DATA_UPDATED'));
      } 
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
  };
  

  return (
    <>
      <HeaderRegister
        title={`${t('CONFIG.PARAMETER_SGA_SATELLITE_TITLE')}`}
        path={"/Models"}
        submitForm={submitFormik}
        isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
        btnBack={false}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setValues
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <div>
                <h5>{t(returnSubTitle(values.selectionTypeId))}</h5>
                <br />
              </div>
              <Form.Group>
                <Form.Floating>                        
                  <div style={{width: '80%', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', boxSizing: 'border-box', flexDirection: 'row'}}>
                    {values.listValues.map((l: configImpositionModelCit) => (   
                      <div key={l.id} style={{width: '33%', boxSizing: 'border-box'}}>                         
                        <Form.Check
                          type="checkbox"
                          id={l.id.toString()}
                          label={values.selectionTypeId === '2' ? t(`PROFILE.${l.fullName.toUpperCase()}`) : values.selectionTypeId === '1' ? t(l.fullName) : l.fullName}
                          checked={selectedList.includes(l.id)}
                          onChange={() => toggleCheckbox(l.id)}
                        />
                      </div>
                    ))}
                  </div>
                </Form.Floating>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SigaSatelliteList;
